<template>
  <v-dialog
    :value="show"
    persistent
    max-width="424"
    @update:returnValue="handleClose">
    <v-card class="confirm-dialog-container">
      <div class="cofirm-dialog-img-wrapper">
        <img src="@/assets/images/mobile_notification.svg" >
      </div>

      <h2
        style="text-align: center;"
        class="headline czn-black--text text--black-87 font-weight--medium">
        {{ $t('dialog.mobileSimpleNotification.title') }}
      </h2>

      <p
        class="confirm-dialog-description subheading czn-black--text text--black-54 text-xs-center">
        {{ $t('dialog.mobileSimpleNotification.content') }}
      </p>

      <div class="confirm-dialog-footer">
        <v-btn
          depressed
          color="primary"
          block
          class="confirm-dialog-footer__btn ma-0"
          @click="handleClose">
          {{ $t('dialog.mobileSimpleNotification.action') }}
        </v-btn>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MobileSimpleNotification',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose () {
      this.$store.commit('system/CLOSE_MOBILE_SIMPLE_NOTIFICATION')
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-dialog-container {
  padding: 24px;
}

.cofirm-dialog-img-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

.confirm-dialog-description {
  letter-spacing: 0.6px;
  margin-bottom: 16px;
}

.confirm-dialog-footer {
  display: flex;
  justify-content: flex-end;

  & .confirm-dialog-footer__btn {
    min-width: 72px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MobileSimpleNotification.vue